import { useNavigate } from "react-router-dom"
import { 
    Box, Button, useToast, 
    Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Stack 
} from "@chakra-ui/react"

import CreatorMap from "../../components/creator/CreatorMap"
import LayerForm from "../../components/creator/LayerForm"
import LayerList from "../../components/creator/LayerList"
import CreatorMapProperties from "../../components/creator/CreatorMapProperties"
import { useMapFromSearchParams } from "./hooks/useMapFromSearchParams"
import { MapProvider } from "../../contexts/MapContext"
import MapWithSidebarLayout from "../../components/MapWithSidebarLayout"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import LoadingOverlay from "../../components/LoadingOverlay"
import StatusOverlay from "../../components/StatusOverlay"


export default function CreatorMapEdit() {

    const toast = useToast()

    const { mapBeingHandled: mapBeingEdited, toDisplay } = useMapFromSearchParams()

    const { maps, isSuccessGetting, isErrorGetting, isSuccessManipulating, isErrorManipulating, message } = useSelector(
        (state) => state.creator
    )

    const navigate = useNavigate()

    // For exporting
    function exportMapButtonPressed(mapBeingEdited) {
        navigate(`/creator/export?mapId=${mapBeingEdited._id}`)
    }

    useEffect(() => {
        if (isSuccessManipulating)
          toast({ title: 'Success!', status: 'success', duration: 4000, isClosable: true, })
    
        if (isErrorManipulating)
          toast({ title: 'Error', message: message, status: `${message}`, duration: 8000, isClosable: true, })
      }, [isSuccessManipulating, isErrorManipulating, maps])


    const MyHelmet = () => {
        return <Helmet>
          <title>Edit map - Creator (Preview) | TrainLookout</title>
          <meta name="description" content="Create elegant rail maps." />
          <meta name="keywords" content="creator, creator mode, rail, journey, record, history, train, trainlookout, train lookout, trainlookout.com, train lookout.com" />
          <link rel="canonical" href="/creator/edit" />
        </Helmet>
    }
    
    
    if (!toDisplay) {
        return (
            <>
                <MyHelmet />
                <LoadingOverlay type="full"/>
            </>
        )
    }
    
    if (isErrorGetting) {
        return (
            <>
                <MyHelmet />
                <StatusOverlay type="modal" text={`Creator mode is currently inaccessible. Please try again later. Error details: ${message}`}/>
            </>
        )
    }

    return (
        <>
            <Box>
                <MapWithSidebarLayout
                    mapComponent={
                        <MapProvider>
                            <CreatorMap creatorMap={mapBeingEdited} />
                        </MapProvider>
                    }
                    sidebarComponent={<LayerForm mapBeingEdited={mapBeingEdited} />}
                />
                
                <Stack direction="row" spacing={4}>
                    {/* Open by default if layers are empty */}
                    <Accordion 
                        allowToggle 
                        defaultIndex={mapBeingEdited.layers && mapBeingEdited.layers.length === 0 ? [0] : []}
                        flex='1'
                    >
                        <AccordionItem>
                            <AccordionButton>
                                <Box flex="1" textAlign="left">
                                    Map properties
                                <AccordionIcon />
                                </Box>
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <CreatorMapProperties map={mapBeingEdited} />
                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>

                    <Button onClick={() => exportMapButtonPressed(mapBeingEdited)}>Export map</Button>
                </Stack>

                <LayerList map={mapBeingEdited} />

            </Box>
        </>
    )
}